import { SVGProps, Ref, forwardRef } from 'react';

export const UserDoubleFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M5.873 1.499c-2.749 0-3.665 1.832-3.665 3.665S3.124 8.83 5.873 8.83 9.54 6.997 9.54 5.164 8.623 1.5 5.873 1.5"
                fill="currentColor"
            />
            <path d="M0 14.5c.597-3.342 3.235-4.502 5.873-4.502s5.277 1.16 5.874 4.502z" fill="currentColor" />
            <path
                d="M10.126 8.83a6 6 0 0 1-.516-.023q.105-.11.203-.226c.848-1.018 1.126-2.292 1.126-3.417s-.278-2.398-1.126-3.416a4 4 0 0 0-.203-.226q.247-.024.516-.023c2.75 0 3.666 1.832 3.666 3.665s-.916 3.666-3.666 3.666"
                fill="currentColor"
            />
            <path
                d="M16 14.5h-2.831l-.044-.246c-.34-1.903-1.253-3.31-2.516-4.243 2.47.136 4.83 1.35 5.39 4.489"
                fill="currentColor"
            />
        </g>
    </svg>
));
UserDoubleFilledSize16Glyph.displayName = 'UserDoubleFilledSize16Glyph';
